import { atom, getDefaultStore } from "jotai";
import { Mod, ModState } from "./types/mod";
import { sortMods } from "./modUtils";

const store = getDefaultStore();
export const modsAtom = atom<Mod[]>([]);
export const sortedModsAtom = atom((get) =>
{
	const mods = get(modsAtom).filter(m => m.state !== ModState.Collection);
	return sortMods(mods);
});

const get = () => store.get(modsAtom);

const set = (mods: Mod[]) => store.set(modsAtom, mods);

const add = (mod: Mod) => store.set(modsAtom, [...store.get(modsAtom), mod]);

const update = (updatedMod: Partial<Mod> & { id: string; }) =>
{
	const mods = store.get(modsAtom);
	store.set(modsAtom, mods.map(m => m.id === updatedMod.id ? { ...m, ...updatedMod } : m));
};

const remove = (id: string) =>
{
	store.set(modsAtom, store.get(modsAtom).filter(m => m.id !== id));
};

const clear = () => store.set(modsAtom, []);

export const modStore = {
	get,
	set,
	add,
	update,
	remove,
	clear,
};